// extracted by mini-css-extract-plugin
export default {"skillsWrapper":"Skills_skillsWrapper__TrSdD","TabPanel":"Skills_TabPanel__OEz8B","tab":"Skills_tab__Fdx2j","separator":"Skills_separator__LQQFu","chip":"Skills_chip__tOK2C"};